import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import api from '../../utils/api';

/**
 * Gate for admin routes. Checks /api/auth/status on mount.
 *  - loading      → spinner
 *  - logged in    → render children
 *  - logged out   → redirect to /login?next=<current path>
 */
export default function RequireAdmin({ children }) {
  const location = useLocation();
  const [state, setState] = useState({ status: 'loading', isLoggedIn: false });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get('/api/auth/status');
        if (cancelled) return;
        setState({
          status: 'ready',
          isLoggedIn: !!(res && res.isLoggedIn),
        });
      } catch (err) {
        if (cancelled) return;
        setState({ status: 'ready', isLoggedIn: false });
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (state.status === 'loading') {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'var(--cream)',
          color: 'var(--plum-soft)',
          fontFamily: 'var(--font-display)',
          fontSize: 22,
          letterSpacing: '0.02em',
        }}
      >
        Checking session…
      </div>
    );
  }

  if (!state.isLoggedIn) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  return children;
}